import { select } from 'modules/dom'

export default function (el) {
  const videoPlay = select('.js-icon-play', el)
  const videoButton = select('.video__button', el)
  const poster = select('.post-video__image')
  const video = select('video', el)

  videoPlay.addEventListener('click', () => {
    video.play()
    video.setAttribute('controls', 'controls')
    videoButton.classList.add('hide')
    if(poster) {
      poster.classList.add('fade-out')
    }
  })
}
